/**
 * Classe com a funcionalidade de menu.
 * @author: adalto.junior
 * Date: 15/10/13
 * Time: 12:00
 */


Greenmile.Survey = Greenmile.Survey || {};
Greenmile.Survey.Menu = Greenmile.Survey.Menu || {};

Greenmile.Survey.Menu = (function () {

    function Menu () {

        initializeLinkMenu = function () {


            var taskMenu = new Monet.UI.FloatMenu(
                [
                    {
                        id: 1,
                        description: Monet.I18n.getResourcesByKey('TaskManager.LinkForm'),
                        icon: 'link',
                        action: (function (scope) {
                            return function () {
                                scope.createLinkFormOverlay(scope);
                            };
                        }(this))
                    },
                    {
                        id: 2,
                        description: Monet.I18n.getResourcesByKey('TaskManager.LinkMap'),
                        icon: 'map',
                        action: (function (scope) {
                            return function () {
                                scope.createMapOverlay(scope);
                            };
                        }(this))
                    }
                ],
                {
                    description: 'description',
                    targetEl: '#btn_link_to_task'
                });

            taskMenu.listProvider = taskList;

            taskMenu.init();

        },

            this.getItemsToMenu = function (item) {

                var items = [];
                var edit = null;
                var deleteItem = null;
                var reorder = null;
                var gridMenu = null;

                if (item) {

                    gridMenu = this.gridMenu;

                    edit = {
                        id: 1,
                        description: Monet.I18n.getResourcesByKey('Greenmile.Survey.Menu.edit'),
                        icon: 'surveyEdit',
                        action: function () {
                            console.log(item);
                        }
                    };

                    deleteItem = {
                        id: 2,
                        description: Monet.I18n.getResourcesByKey('Greenmile.Survey.Menu.delete'),
                        icon: 'surveyDelete',
                        action: function () {
                            console.log(item);
                        }
                    };

                    reorder = {
                        id: 1,
                        description: Monet.I18n.getResourcesByKey('Greenmile.Survey.Menu.reorder'),
                        icon: 'surveyOrder',
                        action: function () {
                            console.log(item);
                        }
                    };

                    items.push(edit);
                    items.push(deleteItem);
                    items.push(reorder);

                }

                return items;

            };

    }

    Menu.prototype = new Greenmile.Grid.Menu();

    return Menu;

}());

